import {Component, NgZone, ViewChild} from '@angular/core';
// @ts-ignore
import {
  AlertController,
  IonicPage,
  LoadingController,
  NavController,
  NavParams,
  Segment,
  ToastController
} from 'ionic-angular';
import {TermsPage} from '../terms/terms';
import {PaymentHttpProvider} from '../../providers/payment-http/payment-http';
import {ValidatorProvider} from '../../providers/validator/validator';
import {AlertProvider} from '../../providers/alert/alert';
import {SystemProvider} from '../../providers/system/system';
import {NewSubscriptionProvider} from '../../providers/new-subscription/new-subscription';
import {EventEmitterProvider} from '../../providers/event-emitter/event-emitter';
import {NewSubscription} from '../../models/newsubscription';
import {SubscriptionServerProvider} from "../../providers/subscription-server/subscription-server";
import {AuthProvider} from "../../providers/auth/auth";
import * as Config from "../../app/app.config";
import {Storage} from '@ionic/storage';
import {VoucherServerProvider} from "../../providers/voucher-server/voucher-server";
import {ProofListPage} from "../proof-list/proof-list";
import {IonicSelectableComponent} from 'ionic-selectable';
import {HttpClient} from "@angular/common/http";

/**
 * Generated class for the NewSubscriptionStep4Page page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
declare var PagSeguroDirectPayment;

@IonicPage()
@Component({
  selector: 'page-new-subscription-step4',
  templateUrl: 'new-subscription-step4.html',
})
export class NewSubscriptionStep4Page {

  hasSubscription: boolean;
  loading: boolean;
  private items: any = [];
  sending: any;
  private doUpdateSubscription: any;
  private itemAmount: any;
  private loginPWOK: boolean;
  public proofExist: boolean;
  private user: any;
  public price: any;
  public price_formatted: any;
  public price_value: any;
  public proof_name: any;
  public proof_linkcode: any;
  public proof_validity: any;
  public proof_description: any;
  public accessKind: any;
  public fullPhone: string;
  public newSubscription: NewSubscription;
  public proofs: any[];
  public proof: any = {
    id: 0,
    name: '',
    proof_description: '',
    validity: 0,
    availabilities: [],
    price: ''
  };
  public proofId: number = Config.proofId;
  public error: boolean = false;
  public errorMessage: string = null;
  clicked = false;
  isShowBillet = false;
  isShowBilletVindi = false;
  isShowPix = false;
  isShowCreditCard = false;
  isApiOk: boolean = false;
  public isSessionOk: boolean = false;
  public paymentMode: string; //default
  public paymentMethod: string; //boleto
  public currency: string; //BRL
  public extraAmount: string; //0.00
  public itemId1: string; //0001
  public itemDescription1: string; //Notebook Prata
  public itemAmount1: string; //24300.00
  public itemQuantity1: string; //1
  public notificationURL: string; //https://sualoja.com.br/notifica.html
  public reference: string; //REF1234
  public senderName: string; //
  public senderCPF: string; //72962940005
  public federalCode: string; //72962940005
  public senderAreaCode: string; //11
  public senderPhone: string; //56273440
  public senderEmail: string; //comprador@uol.com.br
  public senderHash: string; //{{hash_do_comprador}}
  public shippingAddressRequired: boolean; //false
  public email: string;
  public token: string;
  public modalityId: number;
  public applicationId: number;
  public sessionIdPS: string;
  public creditCardNum: string;
  public creditCardCvv: string;
  public creditCardMonthExp: string;
  public creditCardYearExp: string;

  public creditCardToken: string;
  public getCreditCardToken: boolean = false;
  public voucherCode: string = '';
  public voucherDiscountTotal: any;
// INSTALLMENTS
  public installments: any = [];
  public installment: any;
  public installmentConcatenate: any;
  public getValue: any;
  public interest: any;
  public hashExist: boolean;

  public discountVoucherApllied = false;
  public discountFederalCodeApllied = false;

  gotInstallments: boolean = false;
  public requestOptions: any = {
    method: 'GET',
    redirect: 'follow',
    headers: {
      'Access-Control-Allow-Credentials': true,
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'GET',
      'Access-Control-Allow-Headers': 'application/json'
    },
  };
  public installQua: number = Config.installmentsQuantity;
  public installUrl: string = Config.installmentsURL;
  creditPin: string;
  getBrandPS: string;

  public proofTypeId: number = 0;
  public proofType: string = null;
  public proofFormLetter: string = null;
  public proofFormText: string = null;
  public proofNivelId: number = 0;

  @ViewChild(Segment)
  segment: Segment;

  constructor(
    public zone: NgZone,
    public navCtrl: NavController,
    public navParams: NavParams,
    private alertProvider: AlertProvider,
    public alertCtrl: AlertController,
    private validatorProvider: ValidatorProvider,
    private authProvider: AuthProvider,
    private newSubscriptionProvider: NewSubscriptionProvider,
    private subscriptionServerProvider: SubscriptionServerProvider,
    private toastCtrl: ToastController,
    private loadingCtrl: LoadingController,
    private eventEmitterProvider: EventEmitterProvider,
    public paymentHttp: PaymentHttpProvider,
    private voucherServerProvider: VoucherServerProvider,
    private storage: Storage,
    private httpClient: HttpClient,
    private systemProvider: SystemProvider
  ) {
    this.newSubscription = new NewSubscription();
    this.doUpdate(false);
    //console.log("prova: " + Config.proofId);

    let that = this;
    this.doUpdateSubscription = this.eventEmitterProvider.get('do_update').subscribe(() => {
      that.doUpdate(true);
    });

    this.voucherDiscountTotal = 0;

    this.proofTypeId = navParams.get('proofTypeId');
    this.proofType = navParams.get('proofType');
    this.proofFormLetter = navParams.get('proofFormLetter');
    this.proofFormText = navParams.get('proofFormText');
    this.proofNivelId = navParams.get('nivelId');

    let prova = this.proofTypeId + ',' + this.proofFormLetter + ',' + this.proofNivelId;

    switch (prova) {
      case '1,1,1':
        this.proofId = 93;
        break;
      case '1,1,2':
        this.proofId = 94;
        break;
      case '1,1,3':
        this.proofId = 95;
        break;
      case '1,2,1':
        this.proofId = 103;
        break;
      case '1,2,2':
        this.proofId = 104;
        break;
      case '1,2,3':
        this.proofId = 105;
        break;
      case '1,3,1':
        this.proofId = 113;
        break;
      case '1,3,2':
        this.proofId = 114;
        break;
      case '1,3,3':
        this.proofId = 115;
        break;
      case '2,1,1':
        this.proofId = 86;
        break;
      case '2,1,2':
        this.proofId = 87;
        break;
      case '2,1,3':
        this.proofId = 88;
        break;
      case '2,2,1':
        this.proofId = 96;
        break;
      case '2,2,2':
        this.proofId = 97;
        break;
      case '2,2,3':
        this.proofId = 98;
        break;
      case '2,3,1':
        this.proofId = 106;
        break;
      case '2,3,2':
        this.proofId = 107;
        break;
      case '2,3,3':
        this.proofId = 108;
        break;
      case '3,1,1':
        this.proofId = 89;
        break;
      case '3,1,2':
        this.proofId = 90;
        break;
      case '3,2,1':
        this.proofId = 99;
        break;
      case '3,2,2':
        this.proofId = 100;
        break;
      case '3,3,1':
        this.proofId = 109;
        break;
      case '3,3,2':
        this.proofId = 110;
        break;
      case '3,4,1':
        this.proofId = 116;
        break;
      case '3,4,2':
        this.proofId = 117;
        break;
      case '3,4,3':
        this.proofId = 118;
        break;
      case '4,1,1':
        this.proofId = 91;
        break;
      case '4,1,2':
        this.proofId = 92;
        break;
      case '4,2,1':
        this.proofId = 101;
        break;
      case '4,2,2':
        this.proofId = 102;
        break;
      case '4,3,1':
        this.proofId = 111;
        break;
      case '4,3,2':
        this.proofId = 112;
        break;
      case '4,4,1':
        this.proofId = 119;
        break;
      case '4,4,2':
        this.proofId = 120;
        break;
      case '4,4,3':
        this.proofId = 121;
        break;
    }

    if (navParams.get('proofIdRenew')) {
      this.proofId = navParams.get('proofIdRenew');
    }

    if (this.proofId == 116) {
      console.log('hide pages')
    }

  }

  getSenderHash() {

  }

  public doUpdate(force: boolean = true) {
    let that = this;

    if ((!this.loading)) {
      this.loading = true;

      this.items = [];
      if (this.authProvider.hasProofInOtherAccessKind()) {
        this.items.push({
          kind: 'hasProofInOtherAccessKind'
        });
      }

      this.authProvider.getProof(force).subscribe(data => {

        if (!data) {
          this.proofExist = false;
          // that.items.push({
          //   // kind: 'unchecked',
          //   // description: 'Não há prova disponível',
          //   // value: -1
          //
          //
          // });

          that.loading = false;
        } else {
          this.proofExist = true;
          // that.proofProvider.isFinished(data).subscribe((finished: boolean) => {
          //   if (finished) {
          //
          //     that.alertProvider.doWaitingHide();
          //
          //     // DONE: It is now automatically
          //     // that.items.push({
          //     //   kind: 'send_proof_answered',
          //     //   proof: data
          //     // });
          //
          //     // DONE: It is now automatically
          //     that.sendProofAnswered(data.id);
          //   } else {
          //     that.items.push({
          //       kind: 'do_proof',
          //       proof: data
          //     });
          //   }
          //
          //   that.loading = false;
          //   loader.dismiss();
          // }, (error: any) => {
          //   console.log(error);
          //   that.loading = false;
          //   loader.dismiss();
          // });
        }

      }, (error: any) => {
        // loader.dismiss();
        // console.log('Não foi possível obter a prova.', error);
        //
        // let toast = this.toastCtrl.create({
        //   message: 'Não foi possível obter a prova.',
        //   duration: 3000,
        //   position: 'bottom'
        // });
        // toast.present();

        this.loading = false;
      });
    } else {
      // let toast = this.toastCtrl.create({
      //   message: 'Não pode atualizar no momento. Aguarde um pouco e tente novamente.',
      //   duration: 3000,
      //   position: 'bottom'
      // });
      // toast.present();

    }

  }

  ionViewDidLoad() {
    this.isSessionOk = true;
    //that.sessionIdPS = data.session.id;
    this.email = Config.emailPS;
    this.token = Config.tokenPS;
    this.applicationId = Config.applicationId;

    this.loadUserData();
  }

  togglePixDisplay() {
    this.isShowPix = !this.isShowPix;
    this.isShowCreditCard = false;
    this.isShowBillet = false;
  }

  toggleBilletDisplay() {
    this.isShowBillet = !this.isShowBillet;
    this.isShowCreditCard = false;
    this.isShowPix = false;
  }

  toggleCreditCardDisplay() {
    this.isShowCreditCard = !this.isShowCreditCard;
    this.isShowBillet = false;
    this.isShowPix = false;
  }

  ionViewWillEnter() {

    // this.newSubscriptionProvider.load().subscribe((data: any) => {
    //   if (data) {
    //     that.newSubscription = data;
    //   }
    // }, (error: any) => {
    //   console.log(error);
    //   that.loadUserData();
    // });

    this.newSubscription.proofId = this.proofId;
    // // NEW - New Subscription
    // // RNW - Renew Subscription
    // // RNV - Renovation Subscription
    this.newSubscription.accessKind = 'WEB';
    this.newSubscription.camera = true;
    this.newSubscription.kind = "NEW";
    let that = this;
    this.proofs = [];
    this.newSubscriptionProvider.load().subscribe((data: any) => {
      if (data) {
        that.newSubscription = data;
        console.log('that.newSubscription ----->', that.newSubscription);
        let loader = that.loadingCtrl.create({
          content: 'Obtendo os detalhes...',
        });
        loader.present();

        that.price = [];

        this.subscriptionServerProvider.fetchProofPriceDetails(that.newSubscription.proofId, that.newSubscription.kind, that.newSubscription.accessKind, that.newSubscription.camera).subscribe((price: any) => {
          try {
            that.doPriceDetails();
          } catch (ex) {
            that.doNotRetrivedDetail(ex);
          }
          loader.dismiss();
        }, (error: any) => {
          loader.dismiss();
          that.doNotRetrivedDetail(error);
        });
      }
      that.loadUserData();
      that.doPriceDetails();
    }, (error: any) => {
      console.log(error);
    });
  }


  private doNotRetrivedProofs(error = null) {
    this.proofs = [];

    console.log('Não foi possível obter as provas disponíveis.', error);

    let toast = this.toastCtrl.create({
      message: 'Não foi possível obter as provas disponíveis.',
      duration: 3000,
      position: 'bottom'
    });

    toast.present();
  }

  private loadUserData() {
    this.user = [];
    this.user = this.authProvider.getUser();

    if (this.user) {
      this.newSubscription.senderName = this.user.name;
      this.newSubscription.senderCPF = this.user.federalCode.replace(/[^0-9]/g, '');
      this.newSubscription.federalCode = this.user.federalCode;
      this.newSubscription.senderPhone = this.user.phoneMobile;
      this.newSubscription.senderEmail = this.user.email;


      this.senderName = this.user.name;
      this.senderCPF = this.user.federalCode.replace(/[^0-9]/g, '');
      this.federalCode = this.user.federalCode;
      this.senderAreaCode = this.user.phoneMobile;
      this.fullPhone = this.user.phoneMobile;
      this.senderPhone = this.user.phoneMobile.replace(/[^0-9]/g, '');
      this.senderEmail = this.user.email;

      //if(this.senderEmail == 'rodolphoc@gmail.com'){
      //  this.isShowBilletVindi = true;
      //}
      //this.getSenderHash();
    }

    console.log(this.user);
  }

  doPriceDetails() {
    let that = this;
    this.price = [];
    this.proof_name = [];

    this.subscriptionServerProvider.subscriptionByPayment(that.newSubscription).subscribe((data: any) => {
      if ((data) && (data.result)) {

        this.price = data.result.price.value;
        this.price_formatted = data.result.price_formatted;
        this.price_value = data.result.price.value;
        this.newSubscription.itemAmount1 = this.price;
        this.notificationURL = Config.baseUrlGateway + 'status/';
        this.proof_name = data.result.proof.name;
        this.proof_linkcode = data.result.proof.linkCode;
        this.proof_validity = data.result.proof.validity;
        this.proof_description = data.result.proof.description;
        this.newSubscription.voucherId = null;
        this.newSubscription.voucherCode = '';
        this.newSubscription.voucherDiscountTotal = 0;
      } else {
        let toast = this.toastCtrl.create({
          message: 'Não foi possível obter os detalhes do valor da prova.',
          duration: 3000,
          position: 'bottom'
        });
        toast.present();
      }
    }, (error: any) => {
      console.log(error);
      that.alertProvider.doAlert('Erro na busca de dados.', 'Atenção');
    });
  }

  private doNotRetrivedDetail(error = null) {
    this.price = [];
    let toast = this.toastCtrl.create({
      message: 'Não foi possível obter os detalhes da prova.',
      duration: 3000,
      position: 'bottom'
    });
    toast.present();
  }

  onBack() {
    this.newSubscriptionProvider.saveDataAndGoToPage(this.newSubscription, -1);
  }

  goToTermsPage() {
    this.newSubscriptionProvider.saveDataAndGoToPage(this.newSubscription, TermsPage);
  }

  goToNewSubscriptionPage() {

    this.systemProvider.close();

    // this.navCtrl.push(MainPage, {}, {
    //   animation: 'ios-transition'
    // });
  }

  goToProofListPage() {
    this.navCtrl.push(ProofListPage, {}, {
      animation: 'ios-transition'
    });
  }

  doSubscriptionbyBillet() {
    let that = this;

    if (this.validatorProvider.isEmpty(this.newSubscription.senderName)) {
      this.alertProvider.doAlert('Forneça seu nome completo.', 'Atenção');
    } else if (this.validatorProvider.isEmpty(this.newSubscription.senderCPF)) {
      this.alertProvider.doAlert('Forneça seu numero CPF.', 'Atenção');
    } else if (this.isApiOk == false) {
      this.alertProvider.doAlert('Erro de Conexão, por favor tente mais tarde.', 'Atenção');
    } else if (this.isSessionOk == false) {
      this.alertProvider.doAlert('Pag Seguro não esta disponível no momento, por favor tente mais tarde.', 'Atenção');
    } else if (that.newSubscription.senderHash == '') {
      this.alertProvider.doAlert('Pag Seguro não esta disponível no momento, por favor tente novamente.', 'Atenção');
    } else {
      console.log('nova inscricao');
      console.log(that.newSubscription);

      this.paymentHttp.doBillet(that.newSubscription).subscribe((formData: any) => {
        if ((formData) && (formData.result)) {
          console.log('doSubscriptionbyBillet');
        }
      });
      /*
      this.goToNewSubscriptionPage();
      */
    }
  }

  doSubscriptionbyBilletVindi() {
    let that = this;
    let type = 'bank_slip_yapay';
    console.log('boleto vindi')
    console.log(that.newSubscription)
    this.paymentHttp.doBilletVindi(that.newSubscription, type).subscribe((formData: any) => {
      console.log(formData)
    });
  }

  doSubscriptionbyPixVindi() {
    let that = this;
    let type = 'Pix';
    console.log('pix vindi')
    this.paymentHttp.doBilletVindi(that.newSubscription, type).subscribe((formData: any) => {
      console.log(formData)
    });
  }

  doSubscriptionbyCardVindi() {
    let that = this;
    let type = 'credit_card';
    console.log('credit-card vindi')
    this.paymentHttp.doBilletVindi(that.newSubscription, type).subscribe((formData: any) => {
      console.log(formData)
    });
  }

  doSubscriptionbyPix() {
    let that = this;

    if (this.validatorProvider.isEmpty(this.newSubscription.senderName)) {
      this.alertProvider.doAlert('Forneça seu nome completo.', 'Atenção');
    } else if (this.validatorProvider.isEmpty(this.newSubscription.senderCPF)) {
      this.alertProvider.doAlert('Forneça seu numero CPF.', 'Atenção');
    } else if (this.isApiOk == false) {
      this.alertProvider.doAlert('Erro de Conexão, por favor tente mais tarde.', 'Atenção');
    } else {

      this.paymentHttp.doPix(that.newSubscription).subscribe((formData: any) => {
        if ((formData) && (formData.result)) {
          console.log('doSubscriptionbyPix');
        }
      });

      this.goToNewSubscriptionPage();
    }
  }

  /*
  doValidateVoucher() {
    let that = this;

    if (this.validatorProvider.isEmpty(this.newSubscription.voucherCode)) {
      this.alertProvider.doAlert('Digite um voucher válido.', 'Atenção');
    } else {
      this.voucherServerProvider.validateVoucher(this.proofId.toString(), this.newSubscription.voucherCode).subscribe(data => {

        if (data.response.code === 200) {
          this.discountVoucherApllied = true;
          let voucher = data.response.voucher;

          let price_full = this.price;
          let discount_percentage = (voucher.discountPercentage / 100);
          let price_with_discount = (price_full - (discount_percentage * price_full));

          this.price = price_with_discount;
          this.price_formatted = price_with_discount.toFixed(2).toString().replace('.', ',');

          this.voucherDiscountTotal = (price_full - price_with_discount);
          this.newSubscription.voucherDiscountTotal = this.voucherDiscountTotal;
          this.newSubscription.voucherId = voucher.id;

          if(voucher.discountPercentage >= 100) {
            that.isShowBillet = true;
            that.doSubscriptionFree();
          } else {
            this.alertProvider.doAlert('Seu voucher foi validado e o desconto aplicado.', 'Parabéns');
          }

        } else if (data.response.code === 404){
          this.alertProvider.doAlert(data.response.message, 'Atenção');
        }
      }, error => {
        console.log(error);
      });
    }
  }
  */


  doValidateVoucher() {
    let that = this;

    if (this.validatorProvider.isEmpty(this.newSubscription.voucherCode)) {
      this.alertProvider.doAlert('Digite um voucher válido.', 'Atenção');
    } else {

      // valida o voucher vindo do site de compras
      this.voucherServerProvider.validateVoucherApi(this.proof_linkcode.toString(), this.newSubscription.voucherCode).subscribe(data1 => {
        console.log('#### voucher API ####')
        console.log(data1)
        if (data1.response.code === 200) {

          that.isShowBillet = true;
          that.doSubscriptionFree();

        } else {

          // valida o voucher padrão do sistema
          this.voucherServerProvider.validateVoucher(this.proofId.toString(), this.newSubscription.voucherCode).subscribe(data => {
            console.log('#### voucher API 2 ####')
            console.log(data)
            if (data.response.code === 200) {
              this.discountVoucherApllied = true;
              let voucher = data.response.voucher;

              let price_full = this.price;
              let discount_percentage = (voucher.discountPercentage / 100);
              let price_with_discount = (price_full - (discount_percentage * price_full));

              this.price = price_with_discount;
              this.price_formatted = price_with_discount.toFixed(2).toString().replace('.', ',');

              this.voucherDiscountTotal = (price_full - price_with_discount);
              this.newSubscription.voucherDiscountTotal = this.voucherDiscountTotal;
              this.newSubscription.voucherId = voucher.id;

              if (voucher.discountPercentage >= 100) {
                that.isShowBillet = true;
                that.doSubscriptionFree();
              } else {
                this.alertProvider.doAlert('Seu voucher foi validado e o desconto aplicado.', 'Parabéns');
              }

            } else if (data.response.code === 404) {
              this.alertProvider.doAlert(data.response.message, 'Atenção');
            }

          }, error => {
            console.log(error);
          });

        }
      }, error => {
        console.log('erro api voucher');
        console.log(error);
      });

    }
  }


  doValidateUserAggregateAffiliatedFederalCode() {
    let that = this;

    this.user = this.authProvider.getUser();

    if (this.validatorProvider.isEmpty(this.newSubscription.userAggregateAffiliatedFederalCode)) {
      this.alertProvider.doAlert('Digite um CNPJ válido.', 'Atenção');
    } else {
      this.subscriptionServerProvider.validateUserAggregateAffiliatedFederalCode(this.proofId, this.newSubscription.userAggregateAffiliatedFederalCode, this.user.federalCode).subscribe(data => {

        if (data.response.code === 200) {
          let response = data.response;
          this.discountFederalCodeApllied = true;

          let price_full = this.price;
          let discount_percentage = (response.discountPercentage / 100);
          let price_with_discount = (price_full - (discount_percentage * price_full));

          this.price = price_with_discount;
          this.price_formatted = price_with_discount.toFixed(2).toString().replace('.', ',');

          this.voucherDiscountTotal = (price_full - price_with_discount);
          this.newSubscription.voucherDiscountTotal = this.voucherDiscountTotal;

          if (response.discountPercentage >= 100) {
            that.isShowBillet = true;
            that.doSubscriptionFree();
          } else {
            this.alertProvider.doAlert('Seu usuário foi encontrado e o desconto aplicado.', 'Parabéns');
          }
        } else if (data.response.code === 404) {
          this.alertProvider.doAlert(data.response.message, 'Atenção');
        }
      }, error => {
        console.log(error);
      });
    }
  }

  doSubscriptionFree() {
    let that = this;

    if (this.validatorProvider.isEmpty(this.newSubscription.senderName)) {
      this.alertProvider.doAlert('Forneça seu nome completo.', 'Atenção');
    } else if (this.validatorProvider.isEmpty(this.newSubscription.senderCPF)) {
      this.alertProvider.doAlert('Forneça seu numero CPF.', 'Atenção');
    } else {
      console.log('nova inscricao gratuita com voucher');
      console.log(that.newSubscription);
      this.paymentHttp.doFree(that.newSubscription).subscribe((formData: any) => {
        console.log(formData);
        if ((formData) && (formData.result)) {
          console.log('doSubscriptionbyFree');
        }
      });

      //   this.goToProofListPage();
      // this.goToNewSubscriptionPage();

    }
  }

  doSubscriptionbyCreditCard() {
    let that = this;

    if (this.validatorProvider.isEmpty(this.newSubscription.senderName)) {
      this.alertProvider.doAlert('Forneça seu nome completo.', 'Atenção');
    } else if (this.validatorProvider.isEmpty(this.newSubscription.senderCPF)) {
      this.alertProvider.doAlert('Forneça seu numero CPF.', 'Atenção');
    } else if (this.validatorProvider.isEmpty(this.creditCardNum)) {
      this.alertProvider.doAlert('Forneça o numero do cartão de crédito.', 'Atenção');
    } else if (this.validatorProvider.isEmpty(this.creditCardCvv)) {
      this.alertProvider.doAlert('Forneça o numero do código de segurança.', 'Atenção');
    } else if (this.validatorProvider.isEmpty(this.creditCardMonthExp)) {
      this.alertProvider.doAlert('Forneça o mes de vencimento.', 'Atenção');
    } else if (this.validatorProvider.isEmpty(this.creditCardYearExp)) {
      this.alertProvider.doAlert('Forneça o ano de vencimento.', 'Atenção');
    } else if (this.validatorProvider.isEmpty(this.newSubscription.installment)) {
      this.alertProvider.doAlert('Forneça a quantidade de parcelamento do pagamento.', 'Atenção');
    } else if (this.isApiOk == false) {
      this.alertProvider.doAlert('Erro de Conexão, por favor tente mais tarde.', 'Atenção');
    } else if (this.isSessionOk == false) {
      this.alertProvider.doAlert('Pag Seguro não esta disponível no momento, por favor tente mais tarde.', 'Atenção');
    } else if (that.newSubscription.senderHash == '') {
      this.alertProvider.doAlert('Pag Seguro não esta disponível no momento, por favor tente novamente.', 'Atenção');
    } else {
      this.clicked = true;

      PagSeguroDirectPayment.createCardToken({
        cardNumber: this.creditCardNum, // Número do cartão de crédito
        brand: this.getBrandPS, // Bandeira do cartão
        cvv: this.creditCardCvv, // CVV do cartão
        expirationMonth: this.creditCardMonthExp, // Mês da expiração do cartão
        expirationYear: this.creditCardYearExp, // Ano da expiração do cartão, é necessário os 4 dígitos.
        success: function (response) {
          console.log('success createCardToken', response.card.token);
          that.storage.set('creditCardToken', response.card.token);

          setTimeout(function () {
            that.storage.get('creditCardToken').then((val) => {
              console.log('GET creditCardToken', val);
              that.creditCardToken = val;
              console.log('that.creditCardToken --->', that.creditCardToken);

              that.getCreditCardToken = true;
              console.log(that.getCreditCardToken);


            });
          }, 2000);

          setTimeout(function () {
            console.log('getCreditCardToke 431', that.getCreditCardToken);

            that.storage.get('creditCardToken').then((val) => {
              if (val && that.getCreditCardToken) {
                console.log(' PEGEUI creditCardToken', val);
                console.log('getCreditCardToken', that.getCreditCardToken);
                that.newSubscription.creditCardToken = val;
                that.paymentHttp.doCreditCard(that.newSubscription).subscribe((formData: any) => {
                  console.log('doSubscriptionbyCreditCard ----->', formData);
                });
              } else {
                console.log('NÃO PEGUEI creditCardToken', val);
              }

            });
          }, 2000);

          this.goToNewSubscriptionPage();
        },
        error: function (response) {
          //let this = that;
          that.clicked = false;
          // Callback para chamadas que falharam.
          console.log('error createCardToken', response.errors);
          if (response.error == true) {

            that.alertProvider.doAlert('Os dados inseridos não conicidem com o dados do cartão, favor verificar.', 'Atenção');

          } else {
            that.getCreditCardToken = true;
          }

        }

      });


    }
  }

  getInstallments(creditCardNum) {
    let that = this;
    if (!creditCardNum) {
      this.creditPin = null;

    } else {

      let creditCard = creditCardNum;
      this.creditPin = creditCard.slice(0, 6);
      console.log('creditCardNum--->' + creditCard);
      console.log('creditPin--->' + this.creditPin);
    }

    PagSeguroDirectPayment.getBrand({

      cardBin: this.creditPin,
      success: function (response) {
        console.log(response);
        that.getBrandPS = response.brand.name;

        console.log("this.getBrandPS--->" + that.getBrandPS);
        console.log("that.sessionIdPS--->" + that.sessionIdPS);
        console.log("that.price--->" + that.price);
        console.log("that.installQua--->" + that.installQua);
        //bandeira encontrada
        if (that.getBrandPS) {
          setTimeout(function () {

            PagSeguroDirectPayment.getInstallments({
              amount: that.price,
              maxInstallmentNoInterest: that.installQua,
              brand: that.getBrandPS,
              success: function (response) {
                // Retorna as opções de parcelamento disponíveis
                console.log('response--->', response.installments[that.getBrandPS]);
                if (response) {
                  that.installments = response.installments[that.getBrandPS];
                  that.gotInstallments = true;
                  that.clicked = false;

                  console.log("that.installments" + that.installments);
                }
              },
              error: function (response) {
                // callback para chamadas que falharam.
                console.log('error response--->', response);
                that.gotInstallments = false;
                that.clicked = false;
              },
              complete: function (response) {
                // Callback para todas chamadas.
                console.log('complete response--->', response);
              }
            });


            // return that.httpClient.get("https://sandbox.pagseguro.uol.com.br/checkout/v2/installments.json?" +"sessionId="+ that.sessionIdPS +"&amount="+ that.price +"&creditCardBrand="+ that.getBrandPS +"&maxInstallmentNoInterest="+ that.installQua, headerOptions)
            //   .subscribe((response) => {
            //     console.log(response);
            //   }), err => {
            //   console.log(err);
            // };

            //   this.http.get("https://sandbox.pagseguro.uol.com.br/checkout/v2/installments.json?" +"sessionId="+ that.sessionIdPS +"&amount="+ that.price +"&creditCardBrand="+ that.getBrandPS +"&maxInstallmentNoInterest="+ that.installQua).subscribe((response: Response) => {
            //     let data = response.json();
            //     console.log(data);
            //
            // });

            // fetch("https://sandbox.pagseguro.uol.com.br/checkout/v2/installments.json?" +"sessionId="+ that.sessionIdPS +"&amount="+ that.price +"&creditCardBrand="+ that.getBrandPS +"&maxInstallmentNoInterest="+ that.installQua +"", that.requestOptions)
            //   .then(response => response.json())
            //   .then(data => {
            //     console.log(data.installments[that.getBrandPS]);
            //
            //     if(data){
            //       that.installments = data.installments[that.getBrandPS];
            //       that.gotInstallments = true;
            //       that.clicked = false;
            //
            //       console.log("that.installments" + that.installments);
            //     }
            //   })
            //   // .then(response => response.text())
            //   // .then(result => {
            //   //   console.log(result);
            //   //   that.gotInstallments = true;
            //   //   that.installments = result;
            //   //
            //   // })
            //   .catch(error => {
            //     that.gotInstallments = false;
            //     that.clicked = false;
            //     console.log('error', error);
            //   });
          }, 1000);
        }
      },
      error: function (response) {
        //tratamento do erro
      },
      complete: function (response) {
        //tratamento comum para todas chamadas
      }
    });

  }

  onInstallmentChange(event: {
    component: IonicSelectableComponent,
    value: any
  }) {
    this.installmentConcatenate = null;
    if (event.value) {
      if (event.value.interestFree == true) {
        this.installmentConcatenate = event.value.quantity + 'X de ' + event.value.installmentAmount + ' - Sem Juros. Total de ' + event.value.totalAmount;
      } else if (event.value.interestFree == false) {
        this.installmentConcatenate = event.value.quantity + 'X de ' + event.value.installmentAmount + ' - Com juros. Total de ' + event.value.totalAmount;
      } else {
        this.installmentConcatenate = null;
      }


    }

    // this.installments.push(this.installments.installmentConcatenate = this.installmentConcatenate);
    //
    //
    // console.log('this.installmentConcatenate', this.installmentConcatenate);
    // console.log('event.value', event.value);
    // console.log('this.installments', this.installments);
  }

  //                    installmentAmount: 355.32
  //                    interestFree: false
  //                    quantity: 2
  //                     totalAmount: 710.63
  //
  // showInsertOk() {
  //   let alert = this.alertCtrl.create({
  //     title: 'Sucesso!',
  //     message: 'Parabéns seu pedido foi realizado.',
  //     enableBackdropDismiss: false,
  //     buttons: [
  //       {
  //         text: 'Ok',
  //         handler: () => {
  //           this.navCtrl.setRoot('MainPage')
  //
  //         }
  //       }
  //     ]
  //   });
  //   alert.present();
  // }

}




// WEBPACK FOOTER //
// ./src/pages/new-subscription-step4/new-subscription-step4.ts